var _defs, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCanadianFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a4c7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.29,21.29l-1.58-.77c-.3-.15-.45-.49-.35-.8l1.34-4.41c.06-.18-.1-.36-.29-.32l-3.68.62c-.29.05-.59-.09-.72-.36l-1.24-2.36c-.08-.15-.28-.18-.41-.07l-3.86,3.68c-.49.47-1.3.01-1.14-.65l2-8.31c.05-.2-.16-.37-.35-.29l-3.23,1.34c-.33.13-.7,0-.87-.3l-2.81-5.17c-.08-.14-.28-.14-.36,0l-2.81,5.17c-.17.31-.54.44-.87.3l-3.23-1.34c-.19-.08-.4.09-.35.29l2,8.31c.16.66-.65,1.12-1.14.65l-3.86-3.68c-.12-.12-.33-.09-.41.07l-1.24,2.36c-.14.26-.43.41-.72.36l-3.68-.62c-.19-.03-.34.14-.29.32l1.34,4.41c.1.32-.05.66-.35.8l-1.58.77c-.17.08-.19.31-.05.43l8.44,6.8c.24.19.32.51.2.79l-1,2.33c-.08.19.09.39.29.35l8.91-1.95s.09.03.09.08l-.45,8.76c0,.07.05.13.13.13h1.6c.07,0,.13-.06.13-.13l-.45-8.76s.04-.09.09-.08l8.91,1.95c.2.04.37-.16.29-.35l-1-2.33c-.12-.28-.04-.6.2-.79l8.44-6.8c.15-.12.12-.34-.05-.43Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.99,
    width: 18.01,
    height: 42
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 18.01,
    height: 42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCanadianFlag);
export default __webpack_public_path__ + "static/media/Icon-CanadianFlag.b638825010ff6e930a4b0a1a234ddcaf.svg";
export { ForwardRef as ReactComponent };